import React from "react";
import PropTypes from "prop-types";
import { Oval } from "react-loader-spinner";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Input from "components/input";
import { isValidEmail, validateEmail } from "utils/helper";
import { ReactComponent as PayoneerIcon } from "images/profile/payoneer-icon.svg";

function EditPayoneerInformation({
  onDiscard = () => {},
  onSave = () => {},
  isLoading = false,
}) {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});

  const defaultsValues = {
    payoneer: userDetails?.bankDetails?.payoneerEmail ?? "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({ mode: "onChange", defaultValues: defaultsValues });

  return (
    <form
      className="flex flex-col self-stretch rounded-[16px] border-[1px] border-solid border-primary"
      onSubmit={handleSubmit(onSave)}
    >
      <div className="flex p-[24px] justify-between align-center self-stretch border-b border-solid border-[#E4E4E7]">
      <div className="flex items-center w-full gap-[12px]">
          <PayoneerIcon />
          <div className="text-base-black font-semibold text-[24px] not-italic mt-1">
            {t("payoneer")}
          </div>
        </div>
        <div className="flex items-center gap-[12px]">
          <button
            type="button"
            onClick={onDiscard}
            disabled={isLoading}
            className="cursor-pointer whitespace-nowrap flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-default-color bg-white h-[46px]"
          >
            <div className="text-base-black font-bold text-[16px] not-italic">
              {t("Cancel")}
            </div>
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="cursor-pointer whitespace-nowrap flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-primary bg-primary h-[46px]"
          >
            <Oval
              height={30}
              width={30}
              color="#FFF"
              visible={isLoading}
              ariaLabel="oval-loading"
              secondaryColor="#FFF"
              strokeWidth={5}
              strokeWidthSecondary={3}
            />
            <div className="text-white font-bold text-[16px] not-italic">
              {t("saveChangesCta")}
            </div>
          </button>
        </div>
      </div>
      <div className="flex flex-wrap gap-[20px] p-[24px] self-stretch">
        <Input
          label={t("payoneerLabel")}
          isRequired={true}
          type="email"
          name="payoneer"
          placeholder={t("placeHolderType", {
            title: t("payoneerPlaceholder").toLowerCase(),
          })}
          errorMessage={
            errors.payoneer && !isValidEmail(watch("payoneer"))
              ? watch("payoneer") && !isValidEmail(watch("payoneer"))
                ? t("invalidCustomEmail", { customEmail: t("payoneer") })
                : t("errorField", { field: t("payoneer") })
              : ""
          }
          register={register}
          registerArgs={{
            required: t("errorField", { field: t("payoneer") }),
            validate: validateEmail,
          }}
          containerClassName="flex flex-col flex-1 sm-max:grid sm-max:w-full gap-[10px]"
          labelClassName="text-primary font-semibold text-[16px]"
          inputClassName={`flex h-[43px] min-w-[250px] sm-max:w-full items-center gap-[8px] self-stretch rounded-[6px] border-[1px] border-solid ${
            errors.payoneer ? "border-red" : "border-default-color"
          } bg-transparent outline-none text-dark-gray font-regular text-[16px] not-italic  placeholder:font-regular placeholder:text-[16px] placeholder:not-italic placeholder:font-normal py-[16px] px-[14px]`}
        />
      </div>
    </form>
  );
}

EditPayoneerInformation.propTypes = {
  onDiscard: PropTypes.func,
  onSave: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default EditPayoneerInformation;
